export default (handlers, propagate = true, isSync = true) =>
  (reducer = (state) => state) => {
    let initializedHandlers = null

    return (state, payload = {}) => {
      let { action, data } = payload

      if (initializedHandlers == null) {
        initializedHandlers = isSync ? handlers : handlers()
      }

      if (action && initializedHandlers.hasOwnProperty(action)) {
        const newState = initializedHandlers[action](state, payload, reducer)

        return propagate ? reducer(newState, payload) : newState
      }

      return reducer(state, payload)
    }
  }
